import { Button, Flex, Grid, SelectField, TextAreaField, TextField } from "@aws-amplify/ui-react";
import { useEffect, useState } from "react";
import LocalizedStrings from "react-localization";

const FAKE_WAREHOUSES = [
  { id: "wh-0001", name: "Almacén Central" },
  { id: "wh-0002", name: "Almacén Norte" },
  { id: "wh-0003", name: "Almacén Sur" },
  { id: "wh-0004", name: "Almacén Este" },
  { id: "wh-0005", name: "Almacén Oeste" },
];

const FAKE_INPUTS = [
  { id: "input-0001", name: "Glifosato 360 SL", activeIngredient: "Glifosato", unit: "Litro", classification: "Herbicida", physicalType: "Líquido", icaRegistration: "ICA-1234", toxicologicalCategory: "III" },
  { id: "input-0002", name: "Abamectina 1.8%", activeIngredient: "Abamectina", unit: "Mililitro", classification: "Acaricida", physicalType: "Líquido", icaRegistration: "ICA-2345", toxicologicalCategory: "II" },
  { id: "input-0003", name: "Mancozeb 80%", activeIngredient: "Mancozeb", unit: "Kilogramo", classification: "Fungicida", physicalType: "Sólido", icaRegistration: "ICA-3456", toxicologicalCategory: "II" },
  { id: "input-0004", name: "Nitrato de Calcio 15.5-0-0", activeIngredient: "Nitrógeno", unit: "Kilogramo", classification: "Fertilizante", physicalType: "Sólido", icaRegistration: "ICA-4567", toxicologicalCategory: "IV" },
  { id: "input-0005", name: "Extracto de Neem", activeIngredient: "Azadiractina", unit: "Litro", classification: "Insecticida", physicalType: "Líquido", icaRegistration: "ICA-5678", toxicologicalCategory: "IV" },
];

const FAKE_COLLABORATORS = [
  { id: "col-0001", name: "Juan Pérez" },
  { id: "col-0002", name: "María Gómez" },
  { id: "col-0003", name: "Carlos Rojas" },
  { id: "col-0004", name: "Ana Martínez" },
  { id: "col-0005", name: "Luis Díaz" },
];

const FAKE_SHELVES = [
  { id: "shelf-01", name: "Estante A" },
  { id: "shelf-02", name: "Estante B" },
  { id: "shelf-03", name: "Estante C" },
  { id: "shelf-04", name: "Estante D" },
  { id: "shelf-05", name: "Estante E" },
];

const FAKE_SHELF_LEVELS = ["", "1", "2", "3", "4"];

const StockEntryInputForm = ({ onSubmit, type = "create", initialValues = {}, onCancel }) => {
  const defaultState = {
    date: "",
    warehouseId: "",
    warehouseName: "",
    inputId: "",
    inputName: "",
    activeIngredient: "",
    unit: "",
    classification: "",
    physicalType: "",
    withdrawalPeriodDays: "",
    reentryPeriodHours: "",
    icaRegistration: "",
    toxicologicalCategory: "",
    quantity: "",
    performedById: "",
    photoEvidence: "",
    unitPrice: "",
    totalPrice: "",
    supplierName: "",
    supplierTaxId: "",
    purchaseInvoice: "",
    expirationDate: "",
    storageLocation: "",
    shelf: "",
    shelfLevel: "",
    observations: "",
    createdAt: "",
  };

  const [form, setForm] = useState({ ...defaultState, ...initialValues });

  useEffect(() => {
    setForm({ ...defaultState, ...initialValues });
    // If inputId provided, try to enrich fields from FAKE_INPUTS
    if (initialValues.inputId && !initialValues.inputName) {
      const found = FAKE_INPUTS.find((i) => i.id === initialValues.inputId);
      if (found) setForm((f) => ({ ...f, inputName: found.name, activeIngredient: found.activeIngredient, unit: found.unit, classification: found.classification, physicalType: found.physicalType, icaRegistration: found.icaRegistration, toxicologicalCategory: found.toxicologicalCategory }));
    }
    if (initialValues.warehouseId && !initialValues.warehouseName) {
      const found = FAKE_WAREHOUSES.find((w) => w.id === initialValues.warehouseId);
      if (found) setForm((f) => ({ ...f, warehouseName: found.name }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues]);

  const onSubmitForm = () => {
    const payload = { ...form };
    if (!payload.createdAt) payload.createdAt = new Date().toISOString().slice(0, 10);
    onSubmit && onSubmit(payload);
  };

  return (
    <Grid rowGap="12px" columnGap="12px" padding="20px">
      <Grid gap="12px" templateColumns={{ base: "1fr", large: "1fr 1fr" }}>
        <TextField name="date" label={strings.fields.date.label} placeholder="YYYY-MM-DD" value={form.date || ""} onChange={(e) => setForm({ ...form, date: e.target.value })} />
        <SelectField name="warehouseId" label={strings.fields.warehouseId.label} value={form.warehouseId || ""} onChange={(e) => { const val = e.target.value; const found = FAKE_WAREHOUSES.find(w => w.id === val); setForm({ ...form, warehouseId: val, warehouseName: found ? found.name : "" }); }}>
          <option value="">--</option>
          {FAKE_WAREHOUSES.map((w) => <option key={w.id} value={w.id}>{w.name}</option>)}
        </SelectField>
      </Grid>

      <Grid gap="12px" templateColumns={{ base: "1fr", large: "1fr" }}>
        <SelectField name="inputId" label={strings.fields.inputId.label} value={form.inputId || ""} onChange={(e) => { const val = e.target.value; const found = FAKE_INPUTS.find(i => i.id === val); setForm({ ...form, inputId: val, inputName: found ? found.name : "", activeIngredient: found ? found.activeIngredient : "", unit: found ? found.unit : "", classification: found ? found.classification : "", physicalType: found ? found.physicalType : "", icaRegistration: found ? found.icaRegistration : "", toxicologicalCategory: found ? found.toxicologicalCategory : "" }); }}>
          <option value="">--</option>
          {FAKE_INPUTS.map((i) => <option key={i.id} value={i.id}>{i.name}</option>)}
        </SelectField>

      </Grid>

      <Grid gap="12px" templateColumns={{ base: "1fr", large: "1fr 1fr" }}>
        <TextField name="activeIngredient" label={strings.fields.activeIngredient.label} value={form.activeIngredient || ""} onChange={(e) => setForm({ ...form, activeIngredient: e.target.value })} />
        <TextField name="unit" label={strings.fields.unit.label} value={form.unit || ""} onChange={(e) => setForm({ ...form, unit: e.target.value })} />
      </Grid>

      <Grid gap="12px" templateColumns={{ base: "1fr", large: "1fr 1fr" }}>
        <TextField name="classification" label={strings.fields.classification.label} value={form.classification || ""} onChange={(e) => setForm({ ...form, classification: e.target.value })} />
        <TextField name="physicalType" label={strings.fields.physicalType.label} value={form.physicalType || ""} onChange={(e) => setForm({ ...form, physicalType: e.target.value })} />
      </Grid>

      <Grid gap="12px" templateColumns={{ base: "1fr", large: "1fr 1fr" }}>
        <TextField name="withdrawalPeriodDays" label={strings.fields.withdrawalPeriodDays.label} value={form.withdrawalPeriodDays || ""} onChange={(e) => setForm({ ...form, withdrawalPeriodDays: e.target.value })} />
        <TextField name="reentryPeriodHours" label={strings.fields.reentryPeriodHours.label} value={form.reentryPeriodHours || ""} onChange={(e) => setForm({ ...form, reentryPeriodHours: e.target.value })} />
      </Grid>

      <Grid gap="12px" templateColumns={{ base: "1fr", large: "1fr 1fr" }}>
        <TextField name="icaRegistration" label={strings.fields.icaRegistration.label} value={form.icaRegistration || ""} onChange={(e) => setForm({ ...form, icaRegistration: e.target.value })} />
        <TextField name="toxicologicalCategory" label={strings.fields.toxicologicalCategory.label} value={form.toxicologicalCategory || ""} onChange={(e) => setForm({ ...form, toxicologicalCategory: e.target.value })} />
      </Grid>

      <Grid gap="12px" templateColumns={{ base: "1fr", large: "1fr 1fr" }}>
        <TextField name="quantity" label={strings.fields.quantity.label} value={form.quantity || ""} onChange={(e) => setForm({ ...form, quantity: e.target.value })} />
        <SelectField name="performedById" label={strings.fields.performedById.label} value={form.performedById || ""} onChange={(e) => setForm({ ...form, performedById: e.target.value })}>
          <option value="">--</option>
          {FAKE_COLLABORATORS.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
        </SelectField>
      </Grid>

      <TextField name="photoEvidence" label={strings.fields.photoEvidence.label} placeholder="foto1.jpg, foto2.jpg" value={Array.isArray(form.photoEvidence) ? form.photoEvidence.join(", ") : form.photoEvidence || ""} onChange={(e) => setForm({ ...form, photoEvidence: e.target.value })} />

      <Grid gap="12px" templateColumns={{ base: "1fr", large: "1fr 1fr" }}>
        <TextField name="unitPrice" label={strings.fields.unitPrice.label} value={form.unitPrice || ""} onChange={(e) => setForm({ ...form, unitPrice: e.target.value })} />
        <TextField name="totalPrice" label={strings.fields.totalPrice.label} value={form.totalPrice || ""} onChange={(e) => setForm({ ...form, totalPrice: e.target.value })} />
      </Grid>

      <Grid gap="12px" templateColumns={{ base: "1fr", large: "1fr 1fr" }}>
        <TextField name="supplierName" label={strings.fields.supplierName.label} value={form.supplierName || ""} onChange={(e) => setForm({ ...form, supplierName: e.target.value })} />
        <TextField name="supplierTaxId" label={strings.fields.supplierTaxId.label} value={form.supplierTaxId || ""} onChange={(e) => setForm({ ...form, supplierTaxId: e.target.value })} />
      </Grid>

      <TextField name="purchaseInvoice" label={strings.fields.purchaseInvoice.label} placeholder="factura.pdf" value={form.purchaseInvoice || ""} onChange={(e) => setForm({ ...form, purchaseInvoice: e.target.value })} />

      <Grid gap="12px" templateColumns={{ base: "1fr", large: "1fr 1fr" }}>
        <TextField name="expirationDate" label={strings.fields.expirationDate.label} placeholder="YYYY-MM-DD" value={form.expirationDate || ""} onChange={(e) => setForm({ ...form, expirationDate: e.target.value })} />
        <TextField name="storageLocation" label={strings.fields.storageLocation.label} value={form.storageLocation || ""} onChange={(e) => setForm({ ...form, storageLocation: e.target.value })} />
      </Grid>

      <Grid gap="12px" templateColumns={{ base: "1fr", large: "1fr 1fr" }}>
        <SelectField name="shelf" label={strings.fields.shelf.label} value={form.shelf || ""} onChange={(e) => setForm({ ...form, shelf: e.target.value })}>
          <option value="">--</option>
          {FAKE_SHELVES.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
        </SelectField>

        <SelectField name="shelfLevel" label={strings.fields.shelfLevel.label} value={form.shelfLevel || ""} onChange={(e) => setForm({ ...form, shelfLevel: e.target.value })}>
          {FAKE_SHELF_LEVELS.map(l => <option key={l} value={l}>{l || "--"}</option>)}
        </SelectField>
      </Grid>

      <TextAreaField name="observations" label={strings.fields.observations.label} value={form.observations || ""} onChange={(e) => setForm({ ...form, observations: e.target.value })} />

      <Flex justifyContent="end">
        <Button children={strings.fields.buttons.reset} onClick={() => setForm(defaultState)} />
        <Button children={type === "create" ? strings.fields.buttons.create : strings.fields.buttons.save} onClick={onSubmitForm} variation="primary" />
      </Flex>
    </Grid>
  );
};

const strings = new LocalizedStrings({
  es: {
    fields: {
      date: { label: "Fecha" },
      warehouseId: { label: "Almacén" },
      inputId: { label: "Insumo" },
      activeIngredient: { label: "Ingrediente activo" },
      unit: { label: "Unidad" },
      classification: { label: "Clasificación" },
      physicalType: { label: "Tipo" },
      withdrawalPeriodDays: { label: "Periodo de carencia (días)" },
      reentryPeriodHours: { label: "Periodo de reentrada (horas)" },
      icaRegistration: { label: "Registro ICA" },
      toxicologicalCategory: { label: "Categoría toxicológica" },
      quantity: { label: "Cantidad" },
      performedById: { label: "Persona responsable" },
      photoEvidence: { label: "Evidencia fotográfica" },
      unitPrice: { label: "Valor unitario" },
      totalPrice: { label: "Valor total" },
      supplierName: { label: "Proveedor - Nombre" },
      supplierTaxId: { label: "Proveedor - NIT" },
      purchaseInvoice: { label: "Factura de compra (PDF)" },
      expirationDate: { label: "Fecha de vencimiento" },
      storageLocation: { label: "Almacenamiento" },
      shelf: { label: "Estante" },
      shelfLevel: { label: "Nivel del estante" },
      observations: { label: "Observaciones" },
      buttons: { create: "Crear", save: "Guardar", reset: "Restablecer", cancel: "Cancelar" },
    },
  },
});

export default StockEntryInputForm;
